import { createContext, useContext, useState, useEffect, useMemo } from "react";
import { TRANSLATIONS } from "../lib/i18n";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem("gv_lang") : null;
    return saved || "lt";
  });

  useEffect(() => {
    if (typeof window !== "undefined") localStorage.setItem("gv_lang", lang);
  }, [lang]);

  const value = useMemo(() => {
    const t = (key) => TRANSLATIONS[lang]?.[key] ?? TRANSLATIONS.lt[key] ?? key;
    return { lang, setLang, t };
  }, [lang]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used inside I18nProvider");
  return ctx;
}
